import styled from 'styled-components';

export const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${(props) => (props.theme.theme === 'dark' ? '#fff' : '#000')};
  & > img {
    margin-bottom: 80px;
  }
  color: #fff;
  text-align: center;
  line-height: 1.5;
`;
